import { useState } from 'react';
import Step1CharacterType from './onboarding/Step1CharacterType';
import Step2Ethnicity from './onboarding/Step2Ethnicity';
import Step3BodyType from './onboarding/Step3BodyType';
import Step4Appearance from './onboarding/Step4Appearance';
import Step5Final from './onboarding/Step5Final';

const Onboarding = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    gender: '',
    imageStyle: 'anime',
    safetyLevel: 'nude',
    age: 25,
    extraFields: {
      ethnicity: '',
      bodyType: '',
      hairstyle: '',
      hairscolor: '',
      eyeColor: '',
      bodycolor: '',
      wings: ''
    }
  });

  const [history, setHistory] = useState([]);

  const goToStep = (step) => {
    setHistory([...history, currentStep]);
    setCurrentStep(step);
  };

  const goBack = () => {
    if (history.length > 0) {
      const previousStep = history[history.length - 1];
      setHistory(history.slice(0, -1));
      setCurrentStep(previousStep);
    }
  };

  const updateFormData = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [field]: value
      });
    }
  };

  return (
    <div>
      {/* Fixed Header */}
      <header className="fixed-header">
        <img 
          src="https://cdn.lovescape.com/cdn/front/images/lovescape-logo.svg" 
          alt="Lovescape Logo" 
          className="header-logo"
        />
      </header>
      
      {currentStep > 1 && (
        <button className="back-button" onClick={goBack} data-testid="back-button">
          &lt;
        </button>
      )}

      <div className="content-with-header">
      {currentStep === 1 && (
        <Step1CharacterType
          formData={formData}
          updateFormData={updateFormData}
          goToStep={goToStep}
        />
      )}

      {currentStep === 2 && (
        <Step2Ethnicity
          formData={formData}
          updateFormData={updateFormData}
          goToStep={goToStep}
        />
      )}

      {currentStep === 3 && (
        <Step3BodyType
          formData={formData}
          updateFormData={updateFormData}
          goToStep={goToStep}
        />
      )}

      {currentStep === 4 && (
        <Step4Appearance
          formData={formData}
          updateFormData={updateFormData}
          goToStep={goToStep}
        />
      )}

      {currentStep === 5 && (
        <Step5Final
          formData={formData}
        />
      )}
      </div>
    </div>
  );
};

export default Onboarding;
